import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useGlobal } from '../contexts/global';
import { signInSSO, votacao, votacaoFase2 } from '../services/Votacao';
import { getErrorMessage } from '../utils/errorHandler';
import { getFase } from '../utils/fase';
import cidadeSP from '../data/cidades/sao-paulo.json';
import cidadeBH from '../data/cidades/belo-horizonte.json';

const getTemas = () => {
  const activePage = sessionStorage.getItem('cidadeAtivaPage') || '';
  const cidadeAtiva = activePage.includes('belo-horizonte')
    ? cidadeBH
    : cidadeSP;

  const temasObj = {};
  cidadeAtiva.categorias.forEach((cat, index) => {
    const key = cat.slug.replaceAll('-', '_');
    temasObj[key] = {
      id: cat.id || index + 1,
      nome: cat.nome
    };
  });

  return {
    temas: temasObj,
    maxCategorias: cidadeAtiva.categorias.length
  };
};

const LoginGoogle = () => {
  const location = useLocation();
  const history = useHistory();
  const { setSuccess, setError } = useGlobal();

  const vote = (token) => {
    const { temas, maxCategorias } = getTemas();
    const grecaptcha = window.grecaptcha?.enterprise || window.grecaptcha;
    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.REACT_APP_KEY_RECAPTCHA, {
          action: 'submit'
        })
        .then(async (gtoken) => {
          const savedCityPage =
            sessionStorage.getItem('cidadeAtivaPage') || '/';
          const cidadeLogin = savedCityPage.includes('belo-horizonte')
            ? 'belo-horizonte'
            : 'sao-paulo';

          try {
            if (localStorage.getItem('vote_data')) {
              const data = JSON.parse(localStorage.getItem('vote_data'));
              data.token_grecaptcha = gtoken;
              data.google = true;

              if (getFase(cidadeLogin) === '1') {
                const response = await votacao(data, token);
                const { categories } = response.data;

                const votes = categories;
                let urlRedirect = savedCityPage;
                let textRedirect = 'Obrigado por votar nessa categoria!';
                let buttonText = 'Voltar para home';

                const idNextTema = [...Array(maxCategorias).keys()]
                  .map((i) => i + 1)
                  .find((i) => !votes.includes(i));

                if (votes.length < maxCategorias) {
                  const temaEncontrado = Object.entries(temas).find(
                    ([key, t]) => t.id === idNextTema && key != null
                  );

                  if (temaEncontrado) {
                    const [key, t] = temaEncontrado;
                    buttonText = t.nome;
                    urlRedirect = `/votacao/${key}`;
                    textRedirect =
                      'Obrigado por votar nessa categoria!. Sinta-se à vontade para votar também na categoria:';
                  }
                }

                if (votes.length === maxCategorias) {
                  textRedirect =
                    'Obrigado por votar em todas as categorias! Sua participação é muito importante para nós.';
                  buttonText = 'Voltar para home';
                  urlRedirect = savedCityPage;
                }

                Swal.fire({
                  icon: 'warning',
                  text: textRedirect,
                  confirmButtonText: buttonText
                }).then(() => {
                  history.push(urlRedirect);
                });
              } else if (getFase(cidadeLogin) === '2') {
                const response = await votacaoFase2(data, token);
                const { zones } = response.data || {};

                const activePage =
                  sessionStorage.getItem('cidadeAtivaPage') || '';
                const isBH = activePage.includes('belo-horizonte');

                const zonasDisponiveisSP = {
                  regiao_central: {
                    id: 1,
                    nome: 'CENTRO'
                  },
                  zona_norte: {
                    id: 2,
                    nome: 'ZONA NORTE'
                  },
                  zona_leste: {
                    id: 3,
                    nome: 'ZONA LESTE'
                  },
                  zona_sul: {
                    id: 4,
                    nome: 'ZONA SUL'
                  },
                  zona_oeste: {
                    id: 5,
                    nome: 'ZONA OESTE'
                  },
                  melhor_equipe_de_caixa_apresentada_por_mondelez: {
                    id: 6,
                    nome: 'MELHOR EQUIPE DE CAIXA POR MONDELÉZ'
                  },
                  guarulhos: {
                    id: 7,
                    nome: 'PADARIA DE GUARULHOS'
                  },
                  pao_na_chapa_com_catupiry: {
                    id: 8,
                    nome: 'PÃO NA CHAPA COM CATUPIRY'
                  },
                  servico_de_frios_apresentado_por_seara: {
                    id: 9,
                    nome: 'SERVIÇO DE FRIOS POR SEARA'
                  }
                };

                const zonasDisponiveisBH = {
                  centro_sul: {
                    id: 1,
                    nome: 'REGIÃO CENTRO-SUL'
                  },
                  barreiro_oeste: {
                    id: 2,
                    nome: 'REGIÃO BARREIRO/OESTE'
                  },
                  pampulha_noroeste: {
                    id: 3,
                    nome: 'REGIÃO PAMPULHA/NOROESTE'
                  },
                  norte_venda_nova: {
                    id: 4,
                    nome: 'REGIÃO NORTE/VENDA NOVA'
                  },
                  nordeste_leste: {
                    id: 5,
                    nome: 'REGIÃO NORDESTE/LESTE'
                  }
                };

                const zonasDisponiveis = isBH
                  ? zonasDisponiveisBH
                  : zonasDisponiveisSP;

                const votosPadarias = zones || [];

                const zonasRestantes = Object.keys(zonasDisponiveis).filter(
                  (key) => !votosPadarias.includes(zonasDisponiveis[key].id)
                );

                let mensagemFinal = 'Obrigado por votar nesta padaria!';
                let textoBotao = 'Voltar';
                let proximaZonaKey = null;

                if (zonasRestantes.length > 0 && zonasRestantes.length <= 9) {
                  // eslint-disable-next-line prefer-destructuring
                  proximaZonaKey = zonasRestantes[0];
                  const proximaZona = zonasDisponiveis[proximaZonaKey];

                  textoBotao = `Ir para ${proximaZona.nome}`;
                  mensagemFinal = `Obrigado por votar. Você ainda não votou na ${proximaZona.nome}. Clique para votar!`;
                } else {
                  mensagemFinal =
                    'Obrigado por votar em todas as padarias! Sua participação é muito importante para nós.';
                }

                Swal.fire({
                  icon: 'info',
                  text: mensagemFinal,
                  confirmButtonText: textoBotao
                }).then(() => {
                  setSuccess(true);

                  if (proximaZonaKey) {
                    localStorage.setItem('proxima_zona', proximaZonaKey);
                  }

                  history.push(savedCityPage || '/');
                });
              }
            }
          } catch (error) {
            const errorMessage = getErrorMessage(
              error,
              error.response?.status === 422
                ? 'Usuário já votou nessa categoria!'
                : 'Ops! Houve um erro, tente novamente mais tarde.'
            );
            setError(errorMessage);
            history.push(savedCityPage || '/');
          }
        });
    });
  };

  const login = async () => {
    try {
      const resp = await signInSSO(location.search, 'google');
      if (resp && resp.access_token) {
        sessionStorage.setItem('google_access_token', resp.access_token);
      }
      vote(resp.access_token);
    } catch (error) {
      const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
      const errorMessage = getErrorMessage(
        error,
        'Erro ao autenticar com Google. Tente novamente.'
      );
      setError(errorMessage);
      history.push(savedCityPage || '/');
    }
  };

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`,
      () => {}
    );
    login();
  }, []);

  return <></>;
};

export default LoginGoogle;
